import angular from 'angular';
import {
  actionIcon,
  alerts,
  appReports
} from 'app/components/global';
import constants from 'app/constants';
import {
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
  userService
} from 'app/services';
import activeDocument from './activeDocument';
import documentSchemaChangedDialog from './dialog.documentSchemaChangedDialog';
import editPmDocumentDialog from './dialog.editDocumentDialog';
import completedDocument from './completedDocument';
import changeLogDialog from './changeLog/dialog.changeLogDialog';
import changeLogItem from './changeLog/changeLogItem';
import newRecommendedChangesDialog from './dialog.newRecommendedChangesDialog';
import editEndnotesDialog from './dialog.editEndnotesDialog';
import settingsDialog from './dialog.settingsDialog';
import controller from './policy-management.controller';

export const routeConfig = {
  template: require('./policy-management.html'),
  controller: 'PolicyManagementController',
  controllerAs: 'policyManagementVM',
};

export default angular.module('app.components.advisory.pm.policyManagement', [
  actionIcon,
  alerts,
  appReports,
  constants,
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
  userService,
  activeDocument,
  documentSchemaChangedDialog,
  editPmDocumentDialog,
  completedDocument,
  changeLogDialog,
  changeLogItem,
  newRecommendedChangesDialog,
  editEndnotesDialog,
  settingsDialog,
])
  .controller('PolicyManagementController', controller)
  .name;
